{
  "Description": "RU : NNN[-NNN]",
  "RedundantCharacters": " -",
  "ValidationRegex": "^[0-9]{3}([0-9]{3})?$",
  "TestData": {
    "Valid": [
      "125",
      "123456"
    ],
    "Invalid": [
      "x1231s",
      "1231sd",
      "1010101010"
    ]
  }
}